import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { ShieldCheck, Lock, EyeOff, Users } from 'lucide-react';

const pillars = [
  {
    icon: Lock,
    title: 'Structural denial',
    body: 'Admins have no SELECT privilege on private tables (pulses, conversations, turns, insight_units). The database refuses individual reads at the privilege layer, not just RLS.',
  },
  {
    icon: Users,
    title: 'k ≥ 5 floor',
    body: 'Every aggregate in this console is computed inside a SECURITY DEFINER function that suppresses any cell with fewer than 5 distinct employees. The floor is hardcoded server-side.',
  },
  {
    icon: EyeOff,
    title: 'No raw text',
    body: 'The admin insights surface returns excerpt_redacted only. The raw column (excerpt_raw) is structurally excluded from the function return type.',
  },
  {
    icon: ShieldCheck,
    title: 'Identity isolation',
    body: 'Employee identities are stored as per-org salted hashes. Even with database access, identities cannot be cross-correlated between organizations.',
  },
];

export default function AdminTrust() {
  return (
    <div className="space-y-6 max-w-3xl">
      <div>
        <h2 className="text-2xl font-heading font-semibold">Trust charter</h2>
        <p className="text-sm text-muted-foreground">
          The technical guarantees that make this console safe for employees to be honest in.
        </p>
      </div>
      <div className="grid gap-3 md:grid-cols-2">
        {pillars.map((p) => (
          <Card key={p.title}>
            <CardHeader>
              <div className="h-9 w-9 rounded-md bg-primary/10 text-primary flex items-center justify-center mb-2">
                <p.icon className="h-4 w-4" />
              </div>
              <CardTitle className="text-base font-heading">{p.title}</CardTitle>
              <CardDescription className="text-xs">{p.body}</CardDescription>
            </CardHeader>
          </Card>
        ))}
      </div>
    </div>
  );
}
